import { SHADOW_BACKGROUND_LEVEL_2_LIGHT, SPACING_XS_XS } from '@audi/audi-ui-design-tokens';
import styled from 'styled-components';
import { transitionDuration, transitionTiming, zIndexFront, zIndexTop } from '~/styles/tokens';

export const SliderItemsStyle = styled.div<{ sliderItemWidth: number }>`
	position: relative;
	flex-shrink: 0;
	width: ${(props) => props.sliderItemWidth}px;
	filter: ${SHADOW_BACKGROUND_LEVEL_2_LIGHT};
	transition-timing-function: ${transitionTiming};
	transition-duration: ${transitionDuration}ms;
	transition-property: width;

	&.expanded {
		width: 100%;
	}

	&.is-loading:after {
		content: '';
		position: absolute;
		left: 0;
		top: 0;
		width: calc(100% - ${SPACING_XS_XS * 2}px);
		height: calc(100% - ${SPACING_XS_XS}px);
		margin: ${SPACING_XS_XS}px;
		background-color: rgba(255, 255, 255, 0.9);
		z-index: ${zIndexFront};
	}
`;

export const SliderItemsLoaderStyle = styled.div`
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	z-index: ${zIndexTop};
`;
